import React, { useEffect, useState, useRef } from 'react';
import './Hero.css';

const Fig = ({ number, desc }) => {
  const [currentNumber, setCurrentNumber] = useState(0);
  const figRef = useRef(null);
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          if (!hasAnimated) {
            startCounting();
          }
        } else {
          resetCounter();
        }
      },
      { threshold: 0.5 }
    );

    const figElement = figRef.current; // Store ref in a variable

    if (figElement) {
      observer.observe(figElement);
    }

    return () => {
      if (figElement) {
        observer.unobserve(figElement); // Use the variable here
      }
    };
  }, [hasAnimated]); // Fixed dependency array

  const startCounting = () => {
    setHasAnimated(true);
    let start = 0;
    const end = parseInt(number, 10); // Convert the number to an integer
    if (isNaN(end)) return;

    const duration = 2000; // 2 seconds
    const increment = Math.ceil(end / (duration / 50));

    const counter = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCurrentNumber(end);
        clearInterval(counter);
        setHasAnimated(true); // Reset animation trigger
      } else {
        setCurrentNumber(start);
      }
    }, 50);
  };

  const resetCounter = () => {
    setHasAnimated(false);
    setCurrentNumber(0);
  };

  return (
    <div ref={figRef} className="fig">
      <h1 className="fig-num">{currentNumber}</h1> {/* No '+' sign */}
      <h4 className="fig-desc">{desc}</h4>
    </div>
  );
};

export default Fig;
